export default __webpack_public_path__ + "static/lift_w.16ad19e3278f73d8fbafec6bfdc06959.svg";